/**
 * Copyright 2015 MathWorks, Inc.
 * Handling double clicks and single clicks on the same element exclusively is not straight-forward since browsers emit
 * "click", "click", "dblclick" when a user double clicks on an element. What we really want is to not respond to the
 * initial click if it is going to be followed by another one immediately, making it a double click instead.
 * This utility module provides support for adding a single and double-click handler on the same node.
 * It supports a custom delay parameter and falls back to a 200ms delay if none is provided. Any 2 consecutive clicks
 * within the given delay are treated as a double-click.
 */

define({
    /**
     * Returns a new callback which should be attached to the node on which you want to listen for a single and a
     * double-click
     * @param singleClickCallback - This is the callback that you want to get triggered when a single click is detected
     * @param doubleClickCallback - This is the callback that you want to get triggered when a double-click is detected
     * @param delay - The delay in ms to wait for the second click in order to treat it as a double-click
     */
    createCallback: function (singleClickCallback, doubleClickCallback, delay) {
        var clickCount = 0;
        var singleClickTimer;
		var previousTarget;
        if (delay === undefined) {
            delay = 200;
        }
		var startTime;
        return function (event) {
            if ((event.target !== previousTarget) || (Date.now() - startTime >= delay)) {
                clickCount = 0;
            }
            clickCount += 1;
            if (clickCount === 1) {
				previousTarget = event.target;
				startTime = Date.now();
                singleClickTimer = setTimeout(function () {
                    clickCount = 0;
                    singleClickCallback(event);
                }, delay);
            } else if (clickCount === 2) {
                clearTimeout(singleClickTimer);
                clickCount = 0;
				previousTarget = undefined;
				startTime = undefined;
                if (!event.syntheticEvent) {
                    doubleClickCallback(event);
                }
            } else {

            }

        };
    }
});